import { render, staticRenderFns } from "./PassengerTransportationPermissionNameInput.vue?vue&type=template&id=30c7950a"
import script from "./PassengerTransportationPermissionNameInput.vue?vue&type=script&lang=ts"
export * from "./PassengerTransportationPermissionNameInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports